import styled, { css } from 'styled-components'
import { ThemeSelectors, TypeFiesta } from '@at/design-system-foundation'
import { Button } from '@at/design-system-elements'
import { IconInformation } from '@at/design-system-icons'
import { isRedButtonTestActive } from '../../utils/red-button-test'

export const StyledTertiaryButton = styled(Button)<{ $inline?: boolean; $isMobile?: boolean; $isDisabled?: boolean }>`
    ${({ $inline }) =>
        $inline
            ? css`
                  display: block;
                  margin: 10px 10px 10px 0;
              `
            : css`
                  display: flex;
              `}
    &:hover {
        &.atds-button {
            & span > svg {
                fill: ${({ theme }) => theme.color.button.text.soft.hover};
            }
            color: ${({ $isDisabled, theme }) =>
                $isDisabled ? theme.color.button.text.disabled : theme.color.button.text.plain.default};
            background-color: transparent;
        }
    }
    height: 30px;
    align-items: center;
    font-variation-settings: 'wght' 500;
    padding: 0;
    border-radius: 0;
`

export const StyledSearchFacetSectionCountAndSave = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    font-size: 16px;
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupThreeSpacing(theme)};
    @media (max-width: 375px) {
        font-size: 14px;
    }
`

export const StyledResultsFoundMessage = styled(TypeFiesta).attrs({ as: 'span' })`
    font-variation-settings: 'wght' 400;
    font-size: 14px;
    color: ${({ theme }) => theme.color.text.default};
    @media (min-width: 768px) {
        font-size: 16px;
    }
`

export const StyledRetailerResultsFoundMessage = styled(TypeFiesta).attrs({ as: 'span' })`
    font-variation-settings: 'wght' 400;
    font-size: 14px;
    color: ${({ theme }) => theme.color.text.default};
    @media (min-width: 768px) {
        font-size: 16px;
    }
    b {
        font-variation-settings: 'wght' 700;
    }
`

export const StyledIconInformation = styled(IconInformation)`
    margin-top: 1px;
`

export const StyledSearchCountAndAdsDisclaimerContainer = styled.div`
    display: flex;

    svg {
        fill: ${({ theme }) =>
            isRedButtonTestActive ? ThemeSelectors.getDarkBlue(theme) : ThemeSelectors.getActionColor(theme)};
    }
`
